var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.52067 13.9577H6.1665C3.33317 13.9577 1.9165 13.2493 1.9165 9.70768L1.9165 6.16602C1.9165 3.33268 3.33317 1.91602 6.1665 1.91602L11.8332 1.91602C14.6665 1.91602 16.0832 3.33268 16.0832 6.16602V9.70768C16.0832 12.541 14.6665 13.9577 11.8332 13.9577H11.479C11.2594 13.9577 11.0469 14.0639 10.9123 14.241L9.84984 15.6577C9.38234 16.281 8.61734 16.281 8.14984 15.6577L7.08734 14.241C6.974 14.0852 6.71192 13.9577 6.52067 13.9577Z",
    stroke: "#3A3F51",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8307 8.29167H11.8371",
    stroke: "#3A3F51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99676 8.29167H9.00312",
    stroke: "#3A3F51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16278 8.29167H6.16914",
    stroke: "#3A3F51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageUser);
export default __webpack_public_path__ + "static/media/messageUser.ee6c94550e6cb4fb3c6ef3a14aec6f1c.svg";
export { ForwardRef as ReactComponent };